@import 'styles/mixins';
@import 'styles/variables';

.buttonContainer {
  border-radius: 4px;

  &:hover {
    background-color: var(--neutral-5);
  }

  .button {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    color: var(--neutral-50);
    padding: 8px 8px 8px 10px;
    width: 100%;

    svg {
      fill: var(--neutral-40);
    }

    &.disabled {
      color: var(--neutral-30);
      cursor: not-allowed;

      &:hover {
        background-color: transparent;
      }
    }

    .label {
      @include md-regular;
    }
  }

  .rightContent {
    margin-left: auto;
  }

  &.inDropdown {
    width: 208px;
    border-radius: 6px;

    .button {
      padding: 6px 8px;
    }
  }

  &.isSubmenu {
    &:hover {
      background-color: initial;
    }
  }
}
